'use strict';

/* globals google */

const CONST = require('plugin_frontend_core/constants');

const selectors = {
    locationAnchor: '.js-store-availability-modal .js-use-my-location',
    locationError: '.js-store-availability-modal .js-location-error',
    postalCodeField: '.js-store-availability-search-field-postalcode',
    postalCodeForm: '.js-store-availability-search-form',
    product: '.js-product-detail > .js-product',
    productColorAttribute: '.js-store-availability-product-attributes-color',
    productImageAttribute: '.js-store-availability-product-image img',
    searchTrigger: '.js-store-availability-search-trigger',
    storesList: '.js-availability-storeslist',
    storeModalDialog: '.js-store-availability-modal',
    trigger: '.js-check-store-availability'
};

const attributes = {
    notInStockMessage: 'data-resource-notinstock',
    postcodeUnknown: 'data-resource-unknownpostcode',
    resultError: 'data-resource-resulterror',
    patternMismatch: 'data-pattern-mismatch'
};

/**
 * populateHtmlWithStores
 * @param {Object} storesArray - The stores data
 */
function populateHtmlWithStores(storesArray) {
    const $storesList = $(selectors.storesList);

    if (!$storesList.length > 0) {
        console.error('fn populateHtmlWithStores: No stores list available');
        return;
    }

    $storesList.empty();

    if (storesArray.length > 0) {
        const storesHTML = storesArray.map(store => {
            return `
                <div class="store-item mb-1 py-1 px-3 mb-1 d-sm-flex justify-content-between">
                    <div class="store-item__info align-self-center">
                        <div class="store-item__info__name">${store.city} - ${store.address}</div>
                        <div class="store-item__info__openinghours store-item__info__openinghours--${store.isOpen ? 'open' : 'closed'}">${store.storeHoursMessage}</div>
                    </div>
                    <div class="store-item__info__stock store-item__info__stock--${store.productInStock ? 'in-stock' : 'sold-out'} align-self-center mt-1 mt-sm-0">${store.stockMessage}</div>
                </div>
            `;
        });
        $storesList.append(storesHTML);
    } else {
        const notInStockMessage = $storesList.attr(attributes.notInStockMessage);

        if (notInStockMessage) {
            $storesList.html(`<p class="mt-2">${notInStockMessage}</p>`);
        }
    }

    // scroll back to top
    $storesList.scrollTop(0);
}

/**
 * getStoresList
 * @param {string} pid - The product id
 * @param {Object} userLocation - The user's location
 */
function getStoresList(pid, userLocation) {
    if (!pid || !userLocation) {
        console.log('fn getStoresList: Insufficient data');
        return;
    }
    $(selectors.storeModalDialog).spinner().start();

    let getStoresUrl = $(selectors.postalCodeForm).attr(CONST.attributes.action);
    getStoresUrl += `?pid=${pid}`;
    getStoresUrl += `&searchQuery=${userLocation.coords.latitude},${userLocation.coords.longitude}`;

    $.ajax({
        url: getStoresUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            if (data.success) {
                populateHtmlWithStores(data.stores);
            }
            $(selectors.storeModalDialog).spinner().stop();
        },
        error: function () {
            $(selectors.storeModalDialog).spinner().stop();
        }
    });
}


/**
 * useLocation
 */
function useLocation() {
    $(selectors.storeModalDialog).spinner().start();
    navigator.geolocation.getCurrentPosition(function (geoData) {
        const pid = $(selectors.product).attr(CONST.attributes.product.productID);
        $(selectors.locationError).addClass('d-none');
        getStoresList(pid, geoData);
    }, function () {
        $(selectors.locationError).removeClass('d-none');
        $(selectors.storeModalDialog).spinner().stop();
    });
}

/**
 * @private getLatlongFromPostalCode
 * @param {string} postalCode - a postal code
 * @param {string} countryCode - two letters country code
 * @return {Promise} - Promise
 */
function getLatlongFromPostalCode(postalCode, countryCode) {
    const geocoder = new google.maps.Geocoder();
    const componentRestrictions = {
        country: countryCode,
        postalCode: postalCode
    };

    return new Promise(function (resolve, reject) {
        geocoder.geocode({ componentRestrictions: componentRestrictions }, function (results, status) {
            if (status === 'OK') {
                resolve([results[0].geometry.location.lat(), results[0].geometry.location.lng()]);
            } else {
                reject({
                    status: status,
                    message: 'Couldnt\'t find the location for componentRestrictions:' + JSON.stringify(componentRestrictions)
                });
            }
        });
    });
}

/**
 * Returns the country code of the given zipcode by testing against to regexp pattern
 * @param {string} zipcode - zipcode
 * @param {Object} zipCodeCountryCodeMapping - zipCodeCountryCodeMapping
 * @return {string|undefined} - string|undefined
 * @private
 */
function getCountryCodeOfTheZipCode(zipcode, zipCodeCountryCodeMapping) {
    return Object.keys(zipCodeCountryCodeMapping).find(function (countryCode) {
        var pattern = zipCodeCountryCodeMapping[countryCode];
        return new RegExp(pattern).test(zipcode);
    });
}

/**
 * searchPostalCode
 * @param {event} event - The submit event
 */
function searchPostalCode(event) {
    event.preventDefault();
    const pid = $(selectors.product).attr(CONST.attributes.product.productID);
    const $form = $(selectors.postalCodeForm);
    const $field = $form.find(selectors.postalCodeField);
    const zipcode = $field && $field.val();
    const $storesList = $(selectors.storesList);

    if (!new RegExp($field.data(CONST.attributes.pattern)).test(zipcode)) {
        $storesList.empty();
        $storesList.html(`<p class="mt-2">${$field.attr(attributes.patternMismatch)}</p>`);
        return;
    }

    var countryCode = getCountryCodeOfTheZipCode(zipcode, $field.data('pattern-mapping'));

    getLatlongFromPostalCode(zipcode, countryCode).then(result => {
        let location = {
            coords: {
                latitude: result[0],
                longitude: result[1]
            }
        };
        getStoresList(pid, location);
    }).catch(error => {
        $storesList.empty();
        if (error.status === 'ZERO_RESULTS') {
            $storesList.html(`<p class="mt-2">${$storesList.attr(attributes.postcodeUnknown)}</p>`);
        } else {
            $storesList.html(`<p class="mt-2">${$storesList.attr(attributes.resultError)}</p>`);
        }
    });
}

/**
 * showModal
 * @param {event} evt - The click event
 */
function showModal(evt) {
    evt.preventDefault();
    const $productContainer = $(this).closest(CONST.selectors.product.jsProductContainer);
    const $productAttributes = $productContainer.find(CONST.selectors.product.attributes.container);
    let isReady = true;

    $productAttributes.each(function () {
        const $productAttribute = $(this);
        const hasAttributeItems = $productAttribute.find(CONST.selectors.product.attributes.item).length > 0; // does the attribute have any items/variations?
        const noSelectedAttribute = $productAttribute.find(CONST.selectors.product.attributes.selected).length === 0; // does the attribute not have a selected item/variation?
        const $productAttributeMessage = $productContainer.find(CONST.selectors.product.availabilityMsg);

        if (hasAttributeItems && noSelectedAttribute) {
            $productAttribute.addClass(CONST.classes.product.attributes.errorState);
            $productAttributeMessage.removeClass(CONST.classes.dNone);
            isReady = false;
        }
    });

    if (!isReady) {
        return;
    }

    $(selectors.storeModalDialog).parent().modal('show');
}

/**
 * onAttributeSelect
 * @param {event} evt - event
 * @param {Object} response - response
 */
function onAttributeSelect(evt, response) {
    const data = response.data;
    if (!(data.product && data.product.variationAttributes)) {
        return;
    }
    const $modal = $(selectors.storeModalDialog);
    data.product.variationAttributes.forEach(attr => {
        if (attr.attributeId === 'size' && attr.selectedValue) {
            $modal.find(selectors.productColorAttribute).text(attr.selectedValue);
        }
    });
    if (data.product.images && data.product.images.small) {
        $modal.find(selectors.productImageAttribute).attr(CONST.attributes.src, data.product.images.small[0].url);
    }
    // empty previous results
    $modal.find(selectors.storesList).empty();
}

/**
 * Initializes the module
 */
function init() {
    const locationAnchor = document.querySelector(selectors.locationAnchor);
    const postalCodeForm = document.querySelector(selectors.postalCodeForm);
    const searchTrigger = document.querySelector(selectors.searchTrigger);
    const trigger = document.querySelector(selectors.trigger);

    locationAnchor.addEventListener(CONST.events.click, useLocation);
    postalCodeForm.addEventListener(CONST.events.submit, searchPostalCode);
    searchTrigger.addEventListener(CONST.events.click, searchPostalCode);
    $(CONST.selectors.body).on(CONST.events.productAfterAttributeSelect, onAttributeSelect);

    trigger.addEventListener(CONST.events.click, showModal);
}

module.exports = {
    init: init
};
